import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { trpc } from "@/lib/trpc";
import { diaDaSemana, formatarData } from "@/lib/utils";
import { ROTULO_APOIO, type FiltroTipo } from "@/lib/tipoProfissional";

type Modo = "dia" | "semana";

export function ModalCopiarPara({
  modo,
  dataOrigem,
  tipoFiltro,
  open,
  onOpenChange,
  onCopiado,
}: {
  modo: Modo;
  dataOrigem: string;
  tipoFiltro: FiltroTipo;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCopiado: () => void;
}) {
  const [dataDestino, setDataDestino] = useState("");
  const copiarDia = trpc.turnos.copiarParaDia.useMutation({
    onSuccess: (r) => {
      alert(`Copiados ${r.copiados} turnos. Ignorados ${r.ignorados} (já existiam).`);
      onCopiado();
    },
  });
  const copiarSemana = trpc.turnos.copiarParaSemana.useMutation({
    onSuccess: (r) => {
      alert(`Semana copiada. ${r.copiados} turnos criados, ${r.ignorados} ignorados.`);
      onCopiado();
    },
  });

  function executar() {
    if (!dataDestino) return;
    if (modo === "dia") {
      copiarDia.mutate({ dataOrigem, dataDestino, tipoFiltro });
    } else {
      copiarSemana.mutate({ dataOrigem, dataDestino, tipoFiltro });
    }
  }

  const titulo = modo === "dia" ? "Copiar dia inteiro" : "Copiar semana inteira";
  const desc =
    modo === "dia"
      ? `Copiar todos os turnos de ${diaDaSemana(dataOrigem, true)}, ${formatarData(dataOrigem)} para outro dia.`
      : `Copiar a semana de ${formatarData(dataOrigem)} para outra semana (alinhada a partir do dia escolhido).`;
  const filtroLabel =
    tipoFiltro === "todos"
      ? "Todos os profissionais"
      : tipoFiltro === "veterinario"
        ? "Apenas veterinários"
        : tipoFiltro === "apoio"
          ? `Apenas ${ROTULO_APOIO.toLowerCase()}`
          : "Apenas auxiliares";

  const carregando = copiarDia.isPending || copiarSemana.isPending;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{desc}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-md bg-brand-50 px-3 py-2 text-xs text-brand-800">
            Filtro ativo: <strong>{filtroLabel}</strong>. A cópia respeitará esse filtro.
          </div>
          <div className="space-y-1.5">
            <Label>Data destino</Label>
            <Input
              type="date"
              value={dataDestino}
              onChange={(e) => setDataDestino(e.target.value)}
            />
            {modo === "semana" && dataDestino && (
              <p className="text-xs text-slate-500">
                A semana destino começará no domingo correspondente a {formatarData(dataDestino)}.
              </p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={executar} disabled={!dataDestino || carregando}>
            {carregando ? "Copiando..." : "Copiar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
